import script from "./Chart.vue?vue&type=script&setup=true&lang=js"
export * from "./Chart.vue?vue&type=script&setup=true&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=0e8ddc50&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8ddc50"]])

export default __exports__